<template>
  <div class="gift">
    <ul class="gift__ul" ref="giftUl">
      <template v-for="item in gifts">
        <transition
          :key="item.id"
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceOutLeft"
          :duration="{ enter: 1000, leave: 1000 }"
          @after-leave="afterLeave(item)"
          @before-leave="beforeLeave(item)"
        >
          <li v-show="item.show">
            <div>
              <span class="gift__name">{{item.giftInfo.userName}}</span>
              送老师{{item.giftInfo.giftCount}}个
              <img
                class="gift__img"
                :src="item.giftInfo.giftImg"
              />
            </div>
            <!-- <img class="gift__x" src="http://cdn.yxvzb.com/WEB/wx-master/images/mult.png" /> -->
            <!-- <h2 class="gift__num" ref="count1">{{item.count}}</h2> -->
          </li>
        </transition>
      </template>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'LivingGift',
  props: {
    livingStatus: {
      default: ''
    },
    currentUserGift: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      gifts: [], //
      realList: [] // 礼物集合
    };
  },
  methods: {
    beforeLeave() {},
    // 结束后重新从realList取数据，谁离开先用谁
    afterLeave(item) {
      item.count = 0;
      if (this.realList.length != 0) {
        item.giftInfo = this.realList[0];
        this.realList.splice(0, 1);
        item.show = true;
        setTimeout(() => {
          item.show = false;
        }, 2000);
      } else {
        item.giftInfo = {};
      }
    }
  },
  watch: {
    currentUserGift(n) {
      let isCurrentUserGift = false;
      // 当前用户连续送相同礼物
      this.gifts.forEach(item => {
        let { show, giftInfo } = item;
        let { userId, giftName } = giftInfo;
        if (userId == n.userId && giftName == n.giftName && show) {
          item.count += 1;
          item.timer && clearTimeout(item.timer);
          item.timer = setTimeout(() => {
            item.show = false;
          }, 2000);
          isCurrentUserGift = true;
        }
      });
      if (!isCurrentUserGift) {
        this.realList.push(n);
        for (let im of this.gifts) {
          if (!im.show) {
            im.count = 1;
            im.giftInfo = this.realList[0] || {};
            im.show = true;
            im.timer = setTimeout(() => {
              im.show = false;
            }, 2000);
            this.realList.length && this.realList.splice(0, 1);
            break;
          }
        }
      }
    }
    // count1(n) {
    //   if (n > 1) {
    //     this.$refs.count1.className = '';
    //     setTimeout(() => {
    //       this.$refs.count1.className = 'animated rubberBand';
    //     }, 100);
    //   }
    // },
    // count2(n) {
    //   if (n > 1) {
    //     this.$refs.count2.className = '';
    //     setTimeout(() => {
    //       this.$refs.count2.className = 'animated rubberBand';
    //     }, 100);
    //   }
    // }
  },
  created() {
    this.gifts = Array.from([1, 2], n => {
      return {
        id: n,
        giftInfo: {}, // 礼物信息
        show: false, 
        timer: null, // 定时器
        count: 0 // 当前人连续送次数
      };
    });
  }
};
</script>

<style lang="less" scoped>
.gift {
  position: fixed;
  left: 0.267rem;
  top: 8rem;
  z-index: 40;
  div {
    height: 0.91rem;
    margin-bottom: 0.27rem;
  }
  li {
    // width: 4.71rem;
    height: 0.91rem;
    margin-bottom: 0.3rem;
    font-size: 0.37rem;
    color: #999999;
    line-height: 0.91rem;
    padding-left: 0.32rem;
    display: flex;
    align-items: center;
    .giftUserName {
      font-size: 0.37rem;
      color: #027cfa;
      line-height: 0.91rem;
    }
    > div {
      background: #01847f;
      // background: #fd860d;
      color:#fff;
      border-radius: 0 1.33rem 1.33rem 0;
      padding-left: 0.27rem;
      padding-right: 0.43rem;
      height: 0.91rem;
      line-height: 0.91rem;
      display: flex;
      align-items: center;
      box-shadow: 2px 4px 6px rgb(70, 70, 70);
    }
    img {
      width: 0.6rem;
      height: 0.6rem;
      vertical-align: middle;
      margin-left: 0.27rem;
      // margin-top: -.2rem;
    }
    h2 {
      background: linear-gradient(to bottom, #6ce5ff, #2992ff);
      -webkit-background-clip: text;
      color: transparent;
      font-size: 0.96rem;
      line-height: 0.96rem;
      margin-top: -0.2rem;
    }
  }
}

@-webkit-keyframes gotop {
  0% {
    bottom: 0;
    opacity: 1;
  }
  90% {
    bottom: 6.3rem;
    opacity: 1;
  }
  100% {
    bottom: 7rem;
    opacity: 0;
  }
}

@-webkit-keyframes flower1 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: 1.733rem;
  }
}

@-webkit-keyframes flower2 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: 0.667rem;
  }
}

@-webkit-keyframes flower3 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: 0.933rem;
  }
}

@-webkit-keyframes flower4 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: 0.4rem;
  }
}

@-webkit-keyframes flower5 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: -0.133rem;
  }
}

@-webkit-keyframes flower6 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: -0.533rem;
  }
}

@-webkit-keyframes flower7 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: -0.8rem;
  }
}

@-webkit-keyframes explode {
  0% {
    font-size: 1rem;
  }
  50% {
    top: 1.2rem;
  }
  100% {
    top: 1rem;
  }
}
</style>